import React, { useState } from 'react'

import { Grid } from '@material-ui/core'

import { LoadingFeedback } from 'components'
import { ConfirmDataForm, ValidateEmailForm } from './components'

import useSupplierJourney from 'hooks/useSupplierJourney'

const EmailStep = () => {
  const [isLoading, setIsLoading] = useState(false)

  const { supplier } = useSupplierJourney()

  return (
    <>
      <LoadingFeedback open={isLoading} />
      <Grid container spacing={6} justifyContent="center">
        {supplier?.firstAccess ? (
          <ConfirmDataForm setIsLoading={setIsLoading} />
        ) : (
          <ValidateEmailForm setIsLoading={setIsLoading} />
        )}
      </Grid>
    </>
  )
}

export default EmailStep
